export default __webpack_public_path__ + "static/media/plaque1.2858a217.png";